import { SettingValues, BENCHMARK_ORG_SIZE_KEYS } from '@linearb/linjs-common';
import useSettingsService from 'components/hooks/useSettingsService';

const useBenchmarkOrgSizeConfig = () => {
  const { getSettingOrDefinitionValue } = useSettingsService();

  const benchmarkOrgSize =
    getSettingOrDefinitionValue({
      name: SettingValues.BENCHMARK_ORG_SIZE
    }) || BENCHMARK_ORG_SIZE_KEYS.all;

  return {
    benchmarkOrgSize
  };
};

export default useBenchmarkOrgSizeConfig;
